// Generated types for GitHubRepo
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface GitHubRepoReadAPI extends ScopedNodeReadAPI {
  /** owner/name, as GitHub names the repository */
  name: string;
  /** The GitHub account that owns the repository */
  owner?: string;
  /** The repository's name */
  repo_name?: string;
  /** GitHub's id for the repository (its number, as text) */
  github_id: string;
  /** The repository's default branch */
  default_branch?: string;
  /** The repository's page on GitHub */
  html_url?: string;
  /** Whether the repository is private */
  private?: boolean;
  /** False once the organisation disconnected GitHub or the repo left the grant: links to it stay, nothing is read through it */
  connected?: boolean;
  /** When it was disconnected */
  disconnected_at?: string | null;
}

export interface GitHubRepoWriteAPI extends ScopedNodeWriteAPI {
  /** owner/name, as GitHub names the repository */
  name: string;
  /** The GitHub account that owns the repository */
  owner?: string;
  /** The repository's name */
  repo_name?: string;
  /** GitHub's id for the repository (its number, as text) */
  github_id: string;
  /** The repository's default branch */
  default_branch?: string;
  /** The repository's page on GitHub */
  html_url?: string;
  /** Whether the repository is private */
  private?: boolean;
  /** False once the organisation disconnected GitHub or the repo left the grant: links to it stay, nothing is read through it */
  connected?: boolean;
  /** When it was disconnected */
  disconnected_at?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const GitHubRepoReadAPISchema: z.ZodType<GitHubRepoReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  name: z.string(),
  owner: z.string().optional(),
  repo_name: z.string().optional(),
  github_id: z.string(),
  default_branch: z.string().optional(),
  html_url: z.string().optional(),
  private: z.boolean().optional(),
  connected: z.boolean().optional(),
  disconnected_at: z.string().nullable().optional(),
}).passthrough();

export const GitHubRepoWriteAPISchema: z.ZodType<GitHubRepoWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  name: z.string(),
  owner: z.string().optional(),
  repo_name: z.string().optional(),
  github_id: z.string(),
  default_branch: z.string().optional(),
  html_url: z.string().optional(),
  private: z.boolean().optional(),
  connected: z.boolean().optional(),
  disconnected_at: z.string().nullable().optional(),
}).passthrough();
